import React, {Component} from 'react';
import styled from 'styled-components';
import {brk} from "../styles/constants";
import BlockPress from './BlockPress'


const Container = styled.div`

    display : flex;
    flex-wrap : wrap;

    h2 {
        font-family: 'Times', serif;
        font-size : 24px;
        font-weight : 600;
        text-align : center;
    }
    h3, p{ 
        font-family: 'Raleway', sans-serif;
    }
    
    
    h3{
        margin-top : 30px;
        text-align : right;
        font-style : italic;
    }
    p{
        margin-top : 20px;
        text-align : justify;
    }
   
`;





class PressList extends Component {
    render() {
        const {
            content
        } = this.props;

        return (
            <Container >
                {
                    content.map((block, i) =>
                        <BlockPress block={block} key={i}/>
                    )

                }

            </Container>
        )
    }
}


export default PressList;